<template>
  <span class="legacy-collection-counts" :class="{ 'is-compact': compact }">
    <span class="legacy-ticker-total"><span class="counter">{{ tickers }}</span><span class="tickers">tickers</span></span>
    <span class="legacy-entry-total">{{ entries }} entradas</span>
  </span>
</template>
<script>
export default {
  name: 'LegacyCollectionCounts',
  props: {
    tickers: { type: [Number, String], required: true },
    entries: { type: [Number, String], required: true },
    compact: { type: Boolean, default: false }
  }
};
</script>
<style lang="scss" scoped>
.legacy-collection-counts { display: flex; flex-direction: column; gap: 0; text-align: left; }
.legacy-ticker-total { display: flex; align-items: baseline; gap: 6px; line-height: 24px; }
.counter { font-size: 24px; font-weight: 700; }
.tickers { font-size: 12px; font-weight: 500; }
.legacy-entry-total { font-size: 11px; line-height: 14px; color: var(--workspace-muted, #596b7d); }
.is-compact {
  align-items: flex-end;
  .legacy-ticker-total { line-height: 18px; }
  .counter { font-size: 12px; font-weight: 600; }
  .tickers { font-size: 12px; }
}
</style>
